import React from 'react';
import { AppRouter } from './router';
import './App.css';

export function App() {
  return (
    <div className="app-root">
      <AppRouter />
    </div>
  );
}

export default App;
